import { gql } from '@apollo/client'

export const GET_NEARBY = gql`
  query nearby($latitude: Float, $longitude: Float) {
    nearby(latitude: $latitude, longitude: $longitude) {
      risingEvents(first: 8) {
        id
        name
        startDate
        imageUrl
        slug
        availableTicketsCount
        location {
          id
          name
          city {
            id
            name
          }
        }
      }
      popularLocations(first: 6) {
        id
        slug
        image
        name
        background
      }
    }
  }
`
